var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "pix-navbar", class: _vm.environmentClass }, [
    _c("div", { staticClass: "pix-navbar__navigation" }, [
      _c(
        "div",
        { staticClass: "pix-navbar__logo" },
        [
          _c("router-link", { attrs: { tag: "button", to: "/landing" } }, [
            _c("img", { attrs: { src: _vm.jllLogoRoute, alt: "JLL Logo" } }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "pix-navbar__menu" },
        _vm._l(_vm.filteredNavbarItems, function (menuItem) {
          return _c("pix-navbar-menu-item", {
            key: menuItem.label,
            attrs: { "menu-item": menuItem, "is-first-item": "" },
          })
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pix-navbar__actions" }, [
      _c("div", [_c("pix-signalr-manager")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pix-navbar__instance" },
        [_c("pix-flag", { attrs: { country: _vm.instance } })],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "pix-navbar__notifications-button",
          on: { click: _vm.toggleShowNotifications },
        },
        [
          _c("span", { staticClass: "mdi mdi-bell-outline" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.numberOfUnreadNotifications))]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pix-navbar__menu" },
        [
          _c("pix-navbar-menu-item", {
            attrs: {
              "menu-item": _vm.menuItems,
              "expand-direction": _vm.ExpandDirections.Left,
              "is-first-item": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "pix-navbar__login-btn",
          attrs: { title: "logout" },
          on: { click: _vm.fnLogout },
        },
        [_c("span", { staticClass: "mdi mdi-login-variant" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }